import { BASE_SETTINGS_PATH } from '@app/react/components/settings/EmployeesAccounts/utils/paths';

export const ORGANIZATION_PATH = '/organization';
export const ORGANIZATION_BRANDINGS_EDIT_PATH = '/organization/brandings/edit';
export const ORGANIZATION_GENERAL_WAIVER_EDIT_PATH = '/organization/general-waiver/edit';
export const FINANCIAL_PATH = '/financial';
export const HISTORY_PATH = '/history';
export const CREATE_ORGANIZATION = '/profile/new';
export const CREATE_FACILITY_PATH = '/organization/facilities/new';
export const FACILITIES_PATH = '/organization/facilities';
export const SCANNERS_SETTINGS_PATH = '/organization/scanners';
export const SCANNERS_TEST_PATH = '/organization/scanners/scanner';
export const SCANNERS_AUDIO_PATH = '/organization/scanners/audio';
export const SPACES_PATH = '/organization/spaces';
export const MANAGE_PAYMENT_METHODS_PATH = '/customer';
export const CREATE_SPACE_PATH = '/organization/spaces/new';
export const PROMO_CODES_PATH = '/organization/promocodes';
export const STATION_PAGE = 'station';
export const EMPLOYEES_ACCOUNTS_PATH = '/organization/employeesAccounts';
export const NOTIFICATION_GROUPS_REACT_PATH = '/organization/notification-groups';
export const ROLES_MANAGEMENT_PATH = '/organization/rolesManagement';
export const TAXES_PATH = '/organization/taxes';
export const TAXES_PROFILE_PATH = '/organization/taxes/profile';
export const SETTINGS_TAXES_PROFILE_PATH = `${BASE_SETTINGS_PATH}#${TAXES_PROFILE_PATH}`;
export const ACCOUNTING_CODES_PATH = '/organization/accounting-codes';
export const ORG_BANK_ACCOUNTS_PATH = '/organization/bank-accounts';
export const SETTINGS_ORG_BANK_ACCOUNTS_PATH = `${BASE_SETTINGS_PATH}#${ORG_BANK_ACCOUNTS_PATH}`;
export const SETTINGS_ORG_BANK_ACCOUNTS_STRIPE_RETURN_PATH = `${BASE_SETTINGS_PATH}?stripeReturn=true#${ORG_BANK_ACCOUNTS_PATH}`;
export const ACCOUNTING_CODES_PROFILE_PATH = '/organization/accounting-codes/profile';
export const ACCOUNTING_CODES_PROFILE_WITH_ID_PATH = '/organization/accounting-codes/profile/:id?';
export const SETTINGS_ACCOUNTING_CODES_PROFILE_PATH = `${BASE_SETTINGS_PATH}#${ACCOUNTING_CODES_PROFILE_PATH}`;
export const SETTINGS_TIPS_PATH = `${BASE_SETTINGS_PATH}#organization/tips`;

export const DUPLICATE_QUERY_PARAM = 'duplicate';

export const getAccountingCodesProfilePath = (id: number, isDuplicate: boolean): string =>
	`${ACCOUNTING_CODES_PROFILE_PATH}/${id}?${DUPLICATE_QUERY_PARAM}=${isDuplicate}`;

export const ENTITLEMENT_GROUPS_PATH = '/organization/entitlement-groups';
export const ENTITLEMENT_GROUPS_CREATE_PATH = `${ENTITLEMENT_GROUPS_PATH}/create`;
export const ENTITLEMENT_GROUPS_PROFILE_EDIT = `${ENTITLEMENT_GROUPS_PATH}/:id/edit`;
export const ENTITLEMENT_GROUPS_PROFILE_ASSOCIATED_PRODUCTS = `${ENTITLEMENT_GROUPS_PATH}/:id/products`;
export const ENTITLEMENT_GROUPS_PROFILE_WILDCARD = `${ENTITLEMENT_GROUPS_PATH}/:tab(.+)`;

export const getEntitlementGroupEditPath = (id: number): string =>
	ENTITLEMENT_GROUPS_PROFILE_EDIT.replace(':id', String(id));

export const getEntitlementGroupProductsPath = (id: number): string =>
	ENTITLEMENT_GROUPS_PROFILE_ASSOCIATED_PRODUCTS.replace(':id', String(id));

export const CONVERSION_ANALYTICS_PATH = '/organization/marketing/conversion-analytics';
export const RECONCILIATION_PATH = '/reconciliation';
export const TERMINAL_PAYMENT_METHOD_CAPTURE_PATH = '/organization/terminal-payment-method-capture';
export const TERMINAL_SHOP_PATH = '/organization/terminal-shop';

export const getTerminalShopTabPath = (tab: string): string => `${TERMINAL_SHOP_PATH}/${tab}`;
export const TIPS_PATH = '/organization/tips';
export const TIP_CONFIG_PROFILE_PATH = '/organization/tips/profile/:id?';
export const NEW_TIP_CONFIG_PATH = '/organization/tips/profile';
export const DUPLICATE_TIP_CONFIG_QUERY_PARAM = 'duplicateTipConfigId';

export const duplicateTipConfigById = (id: number): string =>
	`${NEW_TIP_CONFIG_PATH}?${DUPLICATE_TIP_CONFIG_QUERY_PARAM}=${id}`;
export const editTipConfigById = (id: number): string => `/organization/tips/profile/${id}`;

export const AUDIT_ACTION_PATH = '/history/:actionId';

export const getAuditActionPath = (actionId: number): string => `${HISTORY_PATH}/${actionId}`;
